import TextLabel from './TextLabel';

describe('TextLabel', () => {
  it('should have correct displayName', () => {
    expect(TextLabel.displayName).toBe('Notification.TextLabel');
  });
});
